import { render, staticRenderFns } from "./cost-structure-list.vue?vue&type=template&id=363735de&scoped=true"
import script from "./cost-structure-list.vue?vue&type=script&lang=js"
export * from "./cost-structure-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363735de",
  null
  
)

export default component.exports